module.exports = __webpack_public_path__ + "static/where-the-wild-things-are-ea5ae3ea7a29b03c57615faca0559b00.jpg";